const thwiftyCat_a = [
  {
    link: "stationary",
    name: "stationary",
    image: "https://cdn.ebtida.com/1704374368517-Stationary.png",
  },
  {
    link: "sports",
    name: "sports",
    image: "https://cdn.ebtida.com/1704374368517-Sports-1.png",
  },
  {
    link: "gaming",
    name: "gaming",
    image: "https://cdn.ebtida.com/1750465966744-games1-thwifty.jpg",
  },
  {
    link: "phone accessories",
    name: "phone_accessories",
    image: "https://cdn.ebtida.com/1704374368517-Phone-Accessories-1.png",
  },
  {
    link: "shoes",
    name: "shoes",
    image: "https://cdn.ebtida.com/1704374368517-Shoes-1.png",
  },
  {
    link: "headphones",
    name: "headphones",
    image: "https://cdn.ebtida.com/1704374368517-Headphones-1.png",
  },
  {
    link: "gaming accessories",
    name: "gaming_accessories",
    image: "https://cdn.ebtida.com/1704374368517-Gaming-Accessories-1.png",
  },
  {
    link: "board games",
    name: "Board Games",
    image: "https://cdn.ebtida.com/1706732527625-Board-Games-x.png",
  },
];

const thwiftyCM = [
  {
    link: "/search/sale",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822599565-MOBILEBANNNER5.jpg",
  },
  {
    link: "/search/beauty",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822599565-MOBILEBANNNER4.jpg",
  },
  {
    link: "/search/fashion",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822599565-MOBILEBANNNER1.jpg",
  },
  {
    link: "/search/sale",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822599565-MOBILEBANNNE2.jpg",
  },
  {
    link: "/search/sport",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822599565-MOBILEBANNNER3.jpg",
  },
 
];

const thwiftyCat_b = [
  {
    link: "Pet & Supplies",
    name: "Pet & Supplies",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536935841-PET-&--SUPPLIES.png",
  },
  {
    link: "gadget & Electronics",
    name: "gadget & Electronics",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536928687-GADGETS-&--ELECTRONICS-.png",
  },
  // {
  //   link: "lifestyle & sports",
  //   name: "Lifestyle & Sports",
  //   image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769537159582-LIFESTYLE-&--SPORTS(1).png",
  // },
  {
    link: "baby & Mom",
    name: "baby & Mom",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536906784-BABY&-MOM.png",
  },
  {
    link: "home & kitchen",
    name: "Home & Kitchen",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536853032-HOME-&--KITCHEN(1).png",
  },
  {
    link: "health personal care",
    name: "Health Personal Care",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536914553-HEALTH-&--PERSONAL-CARE-.png",
  },
  {
    link: "beauty & cosmetics",
    name: "Beauty & Cosmetics",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769536869060-BEAUTY-&--COSMETICS.png",
  }
];

const thwiftyCat_c = [
  {
    link: "watches",
    name: "watches",
    image: "https://cdn.ebtida.com/1704374368517-watches-1.png",
  },
  {
    link: "speakers",
    name: "speakers",
    image: "https://cdn.ebtida.com/1704482914220-Speakers-2.png",
  },
  {
    link: "music instruments",
    name: "music_instruments",
    image: "https://cdn.ebtida.com/1704374368517-Music-Instruments.png",
  },
  {
    link: "toys",
    name: "toys",
    image: "https://cdn.ebtida.com/1750465966744-Toys2-thwifty.jpg",
  },
  {
    link: "gaming console",
    name: "gaming_console",
    image: "https://cdn.ebtida.com/1704374368517-Gaming-Consoles-01.png",
  },
];

const thwiftyFashion = [
  {
    link: "baby and mom",
    name: "Baby & Mom",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431319457-Baby&Mom.jpg",
  },
  {
    link: "home and kitchen",
    name: "Home & Kitchen",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431373563-Home&Kitchen.jpg",
  },
  {
    link: "lifestyle and sports",
    name: "Lifestyle & Sports",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431406881-Lifestyle&Sports.jpg",
  },
  {
    link: "gadgets and electronics",
    name: "Gadgets & Electronics",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431438047-Gadgets&Electronics.jpg",
  },
  {
    link: "beauty and cosmetics",
    name: "Beauty & Cosmetics",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431468688-Beauty&Cosmetics.jpg",
  },
  {
    link: "health and personal care",
    name: "Health & Personal Care",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431498973-HealthPersonalCare.jpg",
  },
];

const category_a = thwiftyCat_a;
const category_b = thwiftyCat_b;
const category_c = thwiftyCat_c;
const fashion = thwiftyFashion;
const carousel = thwiftyCM;

const HomeData = {
  category_a: category_a,
  category_b: category_b,
  category_c: category_c,
  fashion: fashion,
  carousel: carousel,
};

export default HomeData;
